import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["close"];

  async connect() {
    this.closeListeners = [];
    this.closeTargets.forEach((target) => {
      const handler = (e) => {
        e.preventDefault();
        this.element.close();
      };
      target.addEventListener("click", handler);
      this.closeListeners.push({ target, handler });
    });
  }

  disconnect() {
    this.closeListeners.forEach(({ target, handler }) => {
      target.removeEventListener("click", handler);
    });
  }
}
